const STORAGE_KEY = 'biohazardGarageVehicle';
const DEFAULT_MAKES = [
    'Aprilia', 'BMW', 'Can-Am', 'Ducati', 'Harley-Davidson', 'Honda', 'Indian',
    'Kawasaki', 'KTM', 'Polaris', 'Suzuki', 'Triumph', 'Victory', 'Yamaha',
];
const DEFAULT_MODELS = {
    'Harley-Davidson': ['CVO', 'Dyna', 'Electra Glide', 'Fat Boy', 'Low Rider', 'Road Glide', 'Softail', 'Sport Glide', 'Sportster', 'Street Glide', 'Touring'],
    Honda: ['Africa Twin', 'CB', 'CBR', 'CRF', 'Gold Wing', 'Rebel', 'Shadow', 'VTX'],
    Indian: ['Challenger', 'Chief', 'Chieftain', 'FTR', 'Pursuit', 'Roadmaster', 'Scout', 'Springfield'],
    Kawasaki: ['KLR', 'KX', 'Ninja', 'Vulcan', 'Z'],
    Suzuki: ['Boulevard', 'GSX-R', 'Hayabusa', 'V-Strom'],
    Yamaha: ['Bolt', 'FJR', 'MT', 'R-Series', 'Star', 'Tenere', 'Tracer', 'YZ'],
};

function populate(select, values, placeholder) {
    const target = select;
    target.innerHTML = `<option value="">${placeholder}</option>`;
    values.forEach(value => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        target.appendChild(option);
    });
    target.disabled = values.length === 0;
}

function vehicleName(vehicle) {
    return [vehicle.year, vehicle.make, vehicle.model, vehicle.submodel && vehicle.submodel !== 'All' ? vehicle.submodel : '']
        .filter(Boolean)
        .join(' ');
}

function updateGarageDisplay(vehicle) {
    document.querySelectorAll('[data-bh-header-garage-name]').forEach(element => {
        const target = element;
        target.textContent = vehicle ? vehicleName(vehicle) : 'Select your bike';
    });
    document.querySelectorAll('[data-bh-saved]').forEach(element => {
        const target = element;
        target.hidden = !vehicle;
        const name = target.querySelector('[data-bh-saved-name]');
        if (name && vehicle) name.textContent = vehicleName(vehicle);
    });

    document.querySelectorAll('[data-bh-product-fitment]').forEach(element => {
        const emptyState = element.querySelector('[data-bh-product-fitment-empty]');
        const savedState = element.querySelector('[data-bh-product-fitment-saved]');
        const name = element.querySelector('[data-bh-product-fitment-name]');

        if (emptyState) emptyState.hidden = Boolean(vehicle);
        if (savedState) savedState.hidden = !vehicle;
        if (name && vehicle) name.textContent = vehicleName(vehicle);
    });
}

function readSavedVehicle() {
    try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
        return null;
    }
}

function saveVehicle(vehicle) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle));
    updateGarageDisplay(vehicle);
}

async function fetchIndex(url) {
    if (!url) return [];

    try {
        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
        });
        if (!response.ok) return [];
        const data = await response.json();
        return Array.isArray(data.vehicles) ? data.vehicles : [];
    } catch (error) {
        return [];
    }
}

async function loadIndex(primaryUrl, fallbackUrl) {
    const primary = await fetchIndex(primaryUrl);
    if (primary.length) return primary;
    return fetchIndex(fallbackUrl);
}

function unique(values) {
    return [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
}

function findExactUrl(index, vehicle) {
    const candidates = index.filter(item => item.year === vehicle.year
        && item.make === vehicle.make
        && item.model === vehicle.model);

    if (!candidates.length) return '';

    if (vehicle.submodel && vehicle.submodel !== 'All') {
        const exact = candidates.find(item => item.submodel === vehicle.submodel);
        if (exact) return exact.url || '';
    }

    const allModels = candidates.find(item => !item.submodel || item.submodel === 'All');
    return allModels ? allModels.url || '' : '';
}

function setIndexStatus(garageElement, count) {
    const status = garageElement.querySelector('[data-bh-index-status]');
    if (!status) return;

    if (count > 0) {
        status.textContent = `${count.toLocaleString()} verified vehicle selections available.`;
        status.classList.add('is-ready');
        return;
    }

    status.textContent = 'Fitment data is being synchronized. Vehicle selections will open Shop by Bike until verified mappings are published.';
    status.classList.remove('is-ready');
}

export default function garage() {
    const savedVehicle = readSavedVehicle();
    updateGarageDisplay(savedVehicle);

    document.querySelectorAll('[data-bh-garage-clear]').forEach(button => {
        button.addEventListener('click', () => {
            window.localStorage.removeItem(STORAGE_KEY);
            updateGarageDisplay(null);
            const garageElement = button.closest('[data-bh-garage]');
            const form = garageElement && garageElement.querySelector('[data-bh-garage-form]');
            if (form) form.reset();
        });
    });

    document.querySelectorAll('[data-bh-garage]').forEach(async garageElement => {
        const form = garageElement.querySelector('[data-bh-garage-form]');
        if (!form) return;

        const yearSelect = form.querySelector('[data-bh-year]');
        const makeSelect = form.querySelector('[data-bh-make]');
        const modelSelect = form.querySelector('[data-bh-model]');
        const submodelSelect = form.querySelector('[data-bh-submodel]');
        const currentYear = new Date().getFullYear() + 1;
        const fallbackYears = Array.from({ length: 77 }, (_, yearIndex) => String(currentYear - yearIndex));
        const index = await loadIndex(garageElement.dataset.indexUrl, garageElement.dataset.indexFallback);
        const indexedYears = unique(index.map(item => item.year)).sort((a, b) => Number(b) - Number(a));

        setIndexStatus(garageElement, index.length);
        populate(yearSelect, indexedYears.length ? indexedYears : fallbackYears, 'Select year');

        const syncMakes = () => {
            const indexedMakes = unique(index.filter(item => item.year === yearSelect.value).map(item => item.make));
            populate(makeSelect, indexedMakes.length ? indexedMakes : DEFAULT_MAKES, 'Select make');
            populate(modelSelect, [], 'Select model');
            populate(submodelSelect, ['All'], 'All submodels');
        };

        const syncModels = () => {
            const indexedModels = unique(index.filter(item => item.year === yearSelect.value && item.make === makeSelect.value).map(item => item.model));
            const fallback = DEFAULT_MODELS[makeSelect.value] || ['Other'];
            populate(modelSelect, indexedModels.length ? indexedModels : fallback, 'Select model');
            populate(submodelSelect, ['All'], 'All submodels');
        };

        const syncSubmodels = () => {
            const indexed = unique(index.filter(item => item.year === yearSelect.value
                && item.make === makeSelect.value
                && item.model === modelSelect.value)
                .map(item => item.submodel));
            populate(submodelSelect, unique(['All', ...indexed]), 'All submodels');
        };

        yearSelect.addEventListener('change', syncMakes);
        makeSelect.addEventListener('change', syncModels);
        modelSelect.addEventListener('change', syncSubmodels);

        if (savedVehicle) {
            yearSelect.value = savedVehicle.year || '';
            syncMakes();
            makeSelect.value = savedVehicle.make || '';
            syncModels();
            modelSelect.value = savedVehicle.model || '';
            syncSubmodels();
            submodelSelect.value = savedVehicle.submodel || 'All';
        }

        form.addEventListener('submit', event => {
            event.preventDefault();
            const vehicle = {
                year: yearSelect.value,
                make: makeSelect.value,
                model: modelSelect.value,
                submodel: submodelSelect.value || 'All',
            };
            if (!vehicle.year || !vehicle.make || !vehicle.model) return;
            saveVehicle(vehicle);
            const exactUrl = findExactUrl(index, vehicle);
            const fallbackUrl = garageElement.dataset.fallbackUrl || '/shop-by-bike/';
            const params = new URLSearchParams(vehicle);
            window.location.assign(exactUrl || `${fallbackUrl}?${params.toString()}`);
        });
    });
}
